import Icon from './Icon';
import { IconProps, IconCombinedProps } from './Icon.types';

export type { IconProps, IconCombinedProps };
export default Icon;
